import { SchemeQueryProvider } from "__legacy/queries/schemes/SchemeQueryProvider";
import { UpdateSchemeMutationProvider } from "__legacy/queries/schemes/UpdateSchemeMutationProvider";
import { Button, Form, Layout, PageHeader } from "antd";
import { Fragment, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { onError, onFinish, SchemeForm } from "./SchemeForm";

export const Edit: React.FC<{}> = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [errors, setErrors] = useState<string[]>([]);

  return (
    <SchemeQueryProvider variables={{ id }}>
      {({ scheme }) => (
        <UpdateSchemeMutationProvider onError={onError(form, setErrors)} onCompleted={() => navigate("../")}>
          {(loading, mutate) => (
            <Fragment>
              <PageHeader
                ghost={true}
                title={`Edit Scheme ${scheme.name}`}
                extra={
                  <Fragment>
                    <Button onClick={() => navigate("../../")}>Back to list</Button>
                    <Button onClick={() => navigate("../")}>Back to details</Button>
                    <Button type="primary" loading={loading} onClick={() => form.submit()}>
                      Save
                    </Button>
                  </Fragment>
                }
              />
              <Layout.Content className="content">
                <SchemeForm
                  action="update"
                  form={form}
                  handler={onFinish(mutate, {}, { id })}
                  values={scheme}
                  errors={errors}
                />
              </Layout.Content>
            </Fragment>
          )}
        </UpdateSchemeMutationProvider>
      )}
    </SchemeQueryProvider>
  );
};
